define([
    "./transitionFailureReasonModule",
    "./transitionFailureReasonRouter",
    "./edition/TransitionFailureReasonEditionController",
    "./search/TransitionFailureReasonSearchController",
    "./transitionFailureReasonService",
    "./FailureType"
], function () {
});